import { createFileRoute, redirect } from '@tanstack/react-router'
import { APP_HOME_PATH } from '@/lib/app-home'

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context: _context }) => {
    // Check if URL has auth tokens in hash (invite/recovery/magic link flow)
    // Supabase redirects here with tokens in the hash fragment
    const hash = window.location.hash
    if (hash && (hash.includes('access_token') || hash.includes('type=invite') || hash.includes('type=recovery') || hash.includes('type=magiclink'))) {
      // Redirect to auth callback to process the tokens
      // Must explicitly pass hash - TanStack Router's redirect() doesn't preserve it automatically
      throw redirect({
        to: '/auth/callback',
        hash: hash.substring(1), // Remove leading #
      })
    }

    // No auth tokens - redirect to dashboard for authenticated users
    throw redirect({ to: APP_HOME_PATH })
  },
})
